import { PureComponent } from 'react';

import { FriendlyLink } from 'app/src/components/FriendlyLinksRenderer/FriendlyLink';
import type { AttachmentEntity } from './types';
interface AttachmentProps
  extends Pick<
    AttachmentEntity,
    | 'id'
    | 'isFriendly'
    | 'isTrello'
    | 'isTrelloAttachment'
    | 'link'
    | 'text'
    | 'url'
  > {
  onClick?: () => void;
}

// TODO: This thing:
// Get the latest attachment url from the data,
// would mostly likely need handling higher up,
// unless we passed down the data to each entity too
// if entity.type == 'attachment'
//   entity.url = @model.get('data').attachment.url

export class Attachment extends PureComponent<AttachmentProps> {
  render() {
    const {
      link,
      text,
      url = '',
      isFriendly,
      isTrello,
      isTrelloAttachment,
      onClick,
    } = this.props;

    if (link || isFriendly) {
      let options = {};
      if (!isTrello && !isTrelloAttachment) {
        // render friendly link
        options = {
          target: '_blank',
          rel: 'noopener noreferrer',
        };
      }

      return (
        <FriendlyLink hrefProps={{ href: url, onClick, ...options }}>
          {text}
        </FriendlyLink>
      );
    }

    return <span>{text}</span>;
  }
}
